<template>
  <a-form layout="vertical" ref="formRef">
    <Editor v-model="formState.text" :feed="templateParameters.map((p) => (p.name.startsWith('#') ? p.name : `#${p.name}`))" :minimumCharactersFeed="0" />

    <InputActionButtons
      v-model:file="file"
      @select-emoji="handleAddEmoji"
      v-if="!isViewTemplatesEmail"
    />

    <p class="info">Si deseas utilizar una variable, escribe el símbolo "#"</p>
  </a-form>
</template>

<script setup lang="ts">
import { reactive, ref, computed } from "vue";
import { useRoute } from "vue-router";

import { TextItem } from "@/@types/flows/emailTemplates/items";
import { emailTemplateService } from "@/app/flows/emailTemplates/services/EmailTemplate.service";
import { Template } from "@/@types/flows/emailTemplates";

import Editor from "@/app/emails/components/editor/Editor.vue";
import InputActionButtons from "@/app/shared/components/buttons/InputActionButtons.vue";

const props = defineProps<{ item: TextItem; template: Template }>();

const file = ref<File>();

const formState = reactive({ text: props.item.text, variables: props.item.variables });

const templateParameters = computed(() => props.template?.parameters || []);

const handleAddEmoji = (emoji: string) => {
  const lastClosingTagIndex = formState.text.lastIndexOf("</p>");

  const inputText = formState.text;

  formState.text =
    inputText.slice(0, lastClosingTagIndex) + emoji + inputText.slice(lastClosingTagIndex);
};

const route = useRoute();
const isViewTemplatesEmail = computed(() => route.path.includes("/email/templates-email/"));
const getValidatedFormState = async () => {
  const templateId = Number(route.params.id);

  if (file.value) emailTemplateService.uploadFile(templateId, file.value);

  const hasVariables = formState.text.includes("data-mention");

  if (hasVariables) {
    const regex = /data-mention="([^"]+)"/g;

    const matches = formState.text.matchAll(regex);

    const variables = Array.from(matches, (match) => match[1]);

    emailTemplateService.update(templateId, {
      parameters: variables.map((variable) => ({ name: variable })),
    });
  }

  return formState;
};

defineExpose({ getValidatedFormState });
</script>

<style scoped lang="sass">
.info
  margin-top: 16px
  color: $gray-7
  font-style: italic
</style>
